// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"bce91f16","204":"96caddc6","589":"a7c4194d","644":"58a40fc3"}[chunkId] + ".chunk.css";
};